package org.moxultimate.topwithmox.appscrud.main

import androidx.compose.runtime.Immutable
import org.moxultimate.topwithmox.apps.data.AppsResponse

/** State for create/update/delete operations. */
@Immutable
sealed class AppsCRUDState {
    data object Idle : AppsCRUDState()
    data object Loading : AppsCRUDState()
    data class Success(val message: String) : AppsCRUDState()
    data class Error(
        val message: String,
        /** HTTP status code returned by the server, or 0 for network/read errors. */
        val statusCode: Int = 0,
    ) : AppsCRUDState()
}

/** State for the apps list shown in AppsCRUDPage. */
@Immutable
sealed class AppsListState {
    data object Loading : AppsListState()
    data class Success(
        val apps: List<AppsResponse>,
        val hasMore: Boolean = true,
    ) : AppsListState()
    data class Error(val message: String, val statusCode: Int = 0) : AppsListState()
}
